export const VARIANT_SSO = 'SSO';

export const VARIANT_DEFAULT = 'DEFAULT';
